var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { PENDING_GROUP, POSTED_GROUP, StatusValue } from '../../const/status';
import { defaultActivityData } from '../activity-query';
export function normalizer(items) {
    var hash = {};
    var order = [];
    if (items) {
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var txn = item;
            var id = crypto.randomUUID();
            if (txn.status in POSTED_GROUP) {
                order.push(id);
            }
            else {
                order.unshift(id);
            }
            hash[id] = __assign(__assign({}, txn), { localTransactionId: id });
        }
    }
    return {
        items: hash,
        itemsIds: order
    };
}
export var doNotDisplayPostedDateStatuses = [
    StatusValue.PENDING.toLowerCase(),
    StatusValue.CANCELED.toLowerCase(),
    StatusValue.PROCESSING.toLowerCase()
];
export var previouslyVisited = localStorage.getItem('previouslyVisited');
export var appendActivityData = function (data, activityData) {
    var _a, _b, _c, _d;
    return (__assign(__assign({}, data), { activity: {
            items: __assign(__assign({}, (_a = data === null || data === void 0 ? void 0 : data.activity) === null || _a === void 0 ? void 0 : _a.items), (_b = activityData === null || activityData === void 0 ? void 0 : activityData.activity) === null || _b === void 0 ? void 0 : _b.items),
            itemsIds: __spreadArray(__spreadArray([], (_c = activityData === null || activityData === void 0 ? void 0 : activityData.activity) === null || _c === void 0 ? void 0 : _c.itemsIds, true), (_d = data === null || data === void 0 ? void 0 : data.activity) === null || _d === void 0 ? void 0 : _d.itemsIds, true)
        } }));
};
export var getNormalizedData = function (data) {
    if (data) {
        // Spread data including metadata with normalized activity
        return __assign(__assign({}, data), { activity: normalizer(data.activity) });
    }
    return defaultActivityData;
};
export var sortByDate = function (a, b) {
    var dateA = a.postedDate ? new Date(a.postedDate) : new Date(a.createdDate);
    var dateB = b.postedDate ? new Date(b.postedDate) : new Date(b.createdDate);
    return dateB.getTime() - dateA.getTime();
};
export var getGroupedTransactions = function (_a) {
    var _b;
    var activity = _a.activity, isDisplayCondensed = _a.isDisplayCondensed, totalTransactions = _a.totalTransactions;
    var pending = [];
    var posted = [];
    if (((_b = activity === null || activity === void 0 ? void 0 : activity.itemsIds) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        var maxTxn = isDisplayCondensed
            ? Number(totalTransactions)
            : activity.itemsIds.length;
        var unsorted = activity.itemsIds.slice(0, maxTxn).reduce(function (acc, id) {
            var txn = activity.items[id];
            if (txn.status in POSTED_GROUP) {
                acc.posted.push(txn);
            }
            if (txn.status in PENDING_GROUP) {
                acc.pending.push(txn);
            }
            return acc;
        }, { pending: [], posted: [] });
        return {
            pending: unsorted.pending.slice(0).sort(sortByDate),
            posted: unsorted.posted.slice(0).sort(sortByDate)
        };
    }
    return { pending: pending, posted: posted };
};
export var createCssIdByTransactionId = function (transactionId) {
    return "transaction-".concat(transactionId);
};
//# sourceMappingURL=activity-utils.js.map